export default __webpack_public_path__ + "static/Designer-cdc2fb63ad52796049adf64e53c5c41f044e6c9faf0da6bdeecb2e7da5799450.png";